import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../icon/icon';
import { ICONS } from 'shared/constants/images';
import cls from './page-close-button.module.scss';

interface PageCloseButtonProps {
  to: string;
  onClick?: () => void;
  className?: string;
  'aria-label': string;
}

export const PageCloseButton: FC<PageCloseButtonProps> = props => {
  const { to, onClick, className, 'aria-label': ariaLabel } = props;

  const buttonClassName = [cls.pageCloseButton, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Link
      to={to}
      onClick={onClick}
      className={buttonClassName}
      aria-label={ariaLabel}
    >
      <Icon pathToIcon={ICONS.crossBlack} size={14} />
    </Link>
  );
};

export default PageCloseButton;
